var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66382 5.04608C6.47495 5.04608 6.38037 4.81774 6.51392 4.68419L6.97305 4.22506C7.05584 4.14227 7.05584 4.00804 6.97305 3.92526L5.20381 2.15602C5.12102 2.07323 4.98679 2.07323 4.904 2.15602L3.50797 3.55205C3.42514 3.63488 3.29084 3.63483 3.20807 3.55195L0.365945 0.70599C0.283252 0.623186 0.283297 0.489038 0.366046 0.406289L0.664163 0.108172C0.746951 0.0253844 0.881177 0.0253844 0.963965 0.108173L3.20807 2.35228C3.29086 2.43506 3.42508 2.43506 3.50787 2.35228L4.90412 0.956022C4.98687 0.87328 5.121 0.873227 5.20381 0.955903L7.5751 3.32344C7.65791 3.40611 7.79205 3.40606 7.87479 3.32332L8.33403 2.86407C8.46758 2.73052 8.69593 2.82511 8.69593 3.01397V4.83409C8.69593 4.95117 8.60102 5.04608 8.48394 5.04608H6.66382Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsArrowDown);
export default __webpack_public_path__ + "static/media/statistics-arrow-down.8bc8c59d32860b7ea6252d97333db68d.svg";
export { ForwardRef as ReactComponent };